/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithHeading_shoppingWith = {
    readonly title: string | null;
    readonly " $refType": "ShoppingWithHeading_shoppingWith";
};
export type ShoppingWithHeading_shoppingWith$data = ShoppingWithHeading_shoppingWith;
export type ShoppingWithHeading_shoppingWith$key = {
    readonly " $data"?: ShoppingWithHeading_shoppingWith$data;
    readonly " $fragmentRefs": FragmentRefs<"ShoppingWithHeading_shoppingWith">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "ShoppingWithHeading_shoppingWith",
  "type": "ShoppingWith",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '1b23e460addbfdc100cfdf648f8f60fc';
export default node;
